export default __webpack_public_path__ + "static/media/cablegreen-cut.8c59d30d.png";